module.exports = __webpack_public_path__ + "media/images/front/icon_bell-45c20bccbbb6212f6cab2a1af9d2e8df.png";